import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { PARTNER_CHAT_ROUTE_PATHS } from './config';

export const PARTNER_CHAT_ROUTES: TApplicationRoute[] = [
  {
    id: 'partner-conversations',
    path: PARTNER_CHAT_ROUTE_PATHS.partnerConversations,
    component: lazy(() => import('./pages/ConversationsPage')),
    layout: 'default',
    permissions: { scopes: ['partner-chat'] },
    menu: {
      title: 'pages.partnerChat.title',
      icon: 'message_1_line',
    },
  },
  {
    id: 'partner-conversation-detail',
    path: PARTNER_CHAT_ROUTE_PATHS.partnerConversation,
    component: lazy(() => import('./pages/ConversationsPage')),
    layout: 'default',
    permissions: { scopes: ['partner-chat'] },
  },
];
